import keys from 'lodash/fp/keys';
import find from 'lodash/fp/find';
import sum from 'lodash/fp/sum';
import some from 'lodash/fp/some';

const priceTableRegio = {
  10: 3.6,
  20: 4.1,
  30: 4.6,
  40: 5.5,
  50: 7,
  60: 7.5,
  70: 9.4,
  80: 10.8,
  90: 12.3,
  100: 13.3,
  120: 15.7,
  140: 18.6,
  160: 21,
  180: 24.4,
  200: 25.8,
  250: 29.7,
  300: 35,
  350: 40.8,
  400: 46.2,
  500: 55.8,
  600: 67.4,
  700: 79,
  800: 90.6,
  900: 102.2,
  1000: 113.8
};

const priceTableInterRegio = {
  10: 11.6,
  20: 12.1,
  30: 13.1,
  40: 14.5,
  50: 17,
  60: 18.5,
  70: 22.3,
  80: 24.7,
  90: 28.5,
  100: 30,
  120: 34.9,
  140: 41,
  160: 46,
  180: 50.5,
  200: 54.5,
  250: 62,
  300: 69,
  350: 75.5,
  400: 82.5,
  500: 94.5,
  600: 105,
  700: 115.5,
  800: 125,
  900: 134,
  1000: 138.4
};

const seatPriceRegio = 4;

const multipleLegsFeeReduction = 0.095; // 9.5%

let priceBuckets = keys(priceTableRegio).map(kms => parseInt(kms, 10));
priceBuckets.sort((left, right) => left - right);

export function legPrice(leg) {
  if(leg.train.operator !== 'CFR') {
    // TODO: add support for other operators
    return null;
  }
  const distance = sum(leg.segments.map(s => s.distance)) / 1000;
  const priceBucket = find(kms => kms > distance, priceBuckets);

  if(leg.train.type === 'R') {
    return seatPriceRegio + priceTableRegio[priceBucket];
  } else if(leg.train.type === 'IR') {
    return priceTableInterRegio[priceBucket];
  }
  return null;
}

export function routePrice(route) {
  if(some(leg => leg.train.operator !== 'CFR', route.legs)) {
    return null;
  }
  let cost = sum(route.legs.map(legPrice));
  if(route.legs.length > 1) {
    cost -= multipleLegsFeeReduction * (cost - sum(route.legs.map(leg => leg.train.type === 'R' ? seatPriceRegio : 0)));
  }
  return cost;
}



/** WEBPACK FOOTER **
 ** ./src/price.js
 **/